import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./global.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

const tree = (
  <React.StrictMode>
    <App initialPath={window.location.pathname} />
  </React.StrictMode>
);

// The server pre-renders the public landing into #root. When that markup is
// present, hydrate it instead of throwing it away; otherwise mount fresh.
if (root.firstElementChild) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
